import { Box } from '@mui/material'
import React, { memo, useRef } from 'react'
import { VodRowViewProps } from '@/types/vod/vodRowType'
import { useVODStore } from '@/shared/store'
import { pageType } from '@/shared/store/types'
import { useTranslation } from 'react-i18next'
import VodRowViewRecommendations from './VodRowViewRecommendations'
import { maxRecommendationItemHeight } from '@/shared/constants'
import { VodItemsProvider } from '@/features/VOD/context/UseGetVodItemContext/VodItemsContext'
import { selectSetVodPages } from '@/shared/store/storeSelectors/vodSelectors'

interface IVodRowContainer {
    vodRows: VodRowViewProps[]
}

export const VodRowRecommendationsContainer = memo(
    ({ vodRows }: IVodRowContainer) => {
        const containerRef = useRef<HTMLDivElement>(null)
        const vodRowsRef = useRef<HTMLDivElement[]>([])
        const setVodPages = useVODStore(selectSetVodPages)

        const { t: translate } = useTranslation()

        const handleGoToCategoryButtonClick = (
            itemId: string,
            title: string,
            type: pageType
        ): void => {
            setVodPages(itemId, title, type)
        }

        return (
            <Box ref={containerRef} width="100%" minHeight="327px" mt="10px">
                {vodRows.map((row: VodRowViewProps, index) => (
                    <Box
                        key={index}
                        data-index={row.productId}
                        ref={(listElement: HTMLDivElement) => {
                            if (vodRowsRef.current) {
                                vodRowsRef.current[index] = listElement
                            }
                        }}>
                        <VodItemsProvider
                            productId={String(row.productId)}
                            type={row.query || ''}
                            serviceName={row.serviceName || ''}>
                            <VodRowViewRecommendations
                                maxHeight={maxRecommendationItemHeight}
                                productId={row.productId}
                                title={translate('vodItemRecommendation')}
                                handleGoToCategoryButtonClick={
                                    handleGoToCategoryButtonClick
                                }
                            />
                        </VodItemsProvider>
                    </Box>
                ))}
            </Box>
        )
    }
)

VodRowRecommendationsContainer.displayName = 'VodRowRecommendationsContainer'
